<script setup lang="ts">
import { constantRoutes } from '@/router'
import { useRoute, useRouter } from 'vue-router'
import { computed } from 'vue'
import type { AppRouteRecordRaw } from '@mp/types/router'
import { useIsSp } from '@mp/hooks'

const { isNotSp } = useIsSp()
const route = useRoute()
const router = useRouter()
function handleClick(item: AppRouteRecordRaw) {
  if (item.meta?.link)
    return window.open(item.meta?.link as string, '_blank')

  if (!item.path)
    return
  router.replace({ path: item.path })
}

const filterRoute = computed(() => {
  const routers = constantRoutes?.filter(item => item?.meta?.hidden !== true).sort((a, b) => (Number(a.meta?.order) || 0) - (Number(b.meta?.order) || 0))
  return isNotSp ? routers.filter(item => item.name !== 'Capital' && item.name !== 'Cross') : routers
})
</script>

<template>
  <menu class="text-sm flex space-x-2">
    <a
      v-for="item in filterRoute"
      :key="item.name" v-track
      class="h-[64px] px-4 flex items-center text-white cursor-pointer hover:bg-[rgba(0,148,255,0.20)] transition-all"
      :class="{
        'bg-[rgba(0,148,255,0.20)] ': route.path.startsWith(item.path),
      }" :style="{
        'box-shadow': route.path.startsWith(item.path) ? '0 -5px 0 var(--el-color-primary) inset' : 'none',
      }" @click="handleClick(item as AppRouteRecordRaw)"
    >
      {{ item.meta?.title }}
    </a>
  </menu>
</template>
